import { mapGetters } from 'vuex';

const roleMixin = {
  computed: {
    ...mapGetters({
      tokenData: 'tokenData',
      userData: 'userData',
      realCompanyId: 'realCompanyId',
      superAdminData: 'superAdminData',
      consultant: 'consultantData',
    }),
    permissions() {
      return this.tokenData.prm;
    },
    isSuperAdmin() {
      return this.superAdminData === 'false' ? false : this.superAdminData;
    },
    isConsultantSA() {
      return this.userData?.icsa;
    },
    isOwnCompany() {
      return this.consultant?.company_id ? this.consultant?.company_id === this.realCompanyId : true; // eslint-disable-line camelcase
    },
    hasSubordinate() {
      return this.tokenData.subordinate;
    },
    cid() {
      return this.consultant?.company_id || this.userData?.company_id;
    },
  },
  methods: {
    hasAccess(permission) {
      return this.permissions.indexOf(permission) !== -1;
    },
  },
};

export { roleMixin as default };
